<template>
  <on-click-outside @outside="hide">
    <div class="nav hide-scollbar">

      <div class="header flex justify-between items-center pa2">
        <router-link :to="{ name: 'about' }" class="brand">
          <component :is="brand" background='dark'/>
        </router-link>
        <button class="clip-l burger" @click.stop="hide">
          <burger showArrow/>
        </button>
      </div>

      <div v-if="user.demo" class="pa3 bt b--gray tc">
        <router-link :to="{ name: 'demo' }" class="link">
          <span class="f6 gold">демо режим</span>
        </router-link>
      </div>

      <logged-user/>

      <side-nav-menu :tree="children(root.code)"/>

    </div>
  </on-click-outside>
</template>

<script>
import OnClickOutside from '@/components/ui/OnClickOutside.vue'
import SideNavMenu from '@/components/SideNavMenu.vue'
import ContractBrand from '@/components/brand/Contract.vue'
import AssistantBrand from '@/components/brand/Assistant.vue'
import Burger from './Burger.vue'
import LoggedUser from '@/components/LoggedUser.vue'
import { isDocApplication } from '@/utils/app.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    OnClickOutside,
    SideNavMenu,
    ContractBrand,
    AssistantBrand,
    Burger,
    LoggedUser
  },
  created () {
    // HACK вот такой интересный хак чтобы закрыть SideNav при кликании на меню
    this.$router.beforeResolve((to, from, next) => {
      this.hide()
      next()
    })
  },
  computed: {
    ...mapGetters('settings/menu', ['root', 'children']),
    ...mapGetters('session', ['user']),
    brand () {
      return isDocApplication() ? 'ContractBrand' : 'AssistantBrand'
    }
  },
  methods: {
    hide () {
      this.$emit('hide')
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 58px;
}
.brand {
  display: flex;
  align-items: center;
  width: auto;
  padding: .25rem;
  & svg {
    height: 40px;
    width: 90%;
  }
}
.burger {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: auto;
  background: transparent;
  border: 0;
  & svg {
    height: 35px;
    width: 35px;
  }
}
.nav {
  background-color: #334E68;
  color: #d5dae6;
  overflow-y: scroll;
  height: 100%;
}
</style>
